export default __webpack_public_path__ + "static/media/toggle-sliders-b.b262e7e4.svg";